import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import { CREATE_WALLET, LOAD_WALLETS_LIST, RESET_WALLETS } from "@/store/const/wallets";

export default {
  namespaced: true,
  state: {
    wallets: {
      list: [],
      pagination: {},
    },
    statuses: {
      checking: 'На проверке',
      wait: 'Ожидание',
      in_progress: 'Выполняется',
      error: 'Ошибка',
      success: 'Выполнен',
    }
  },
  getters: {
    wallets: state => state.wallets,
    statuses: state => state.statuses,
  },
  actions: {
    [LOAD_WALLETS_LIST]: async ({ dispatch }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_WALLETS_LIST,
        namespace: 'wallets',
        params,
      }, { root: true });
    },
    [CREATE_WALLET]: async ({ dispatch }) => {
      return await dispatch(HTTP_POST, {
        method: CREATE_WALLET,
        namespace: 'wallets',
        no_commit: true,
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_WALLETS_LIST]: (state, { data }) => {
      Vue.set(state.wallets, 'list', data.list);
      Vue.set(state.wallets, 'pagination', data.pagination);
    },
    [RESET_WALLETS]: (state) => {
      Vue.set(state, 'wallets', { pagination: {}, list: []});
    }
  },
};
